import { render, staticRenderFns } from "./SingleVideo.vue?vue&type=template&id=2430b4f5"
import script from "./SingleVideo.vue?vue&type=script&lang=js"
export * from "./SingleVideo.vue?vue&type=script&lang=js"
import style0 from "./SingleVideo.vue?vue&type=style&index=0&id=2430b4f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports